import { SIZE_CHANGE_SHOW_TABLE } from './constants'

// eslint-disable-next-line
export function sizeChangeShowTable(module, id, blockKey, customData) {
    return {
        type: SIZE_CHANGE_SHOW_TABLE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
